import { PasswordModule } from 'primeng/password';
export class DataLogin {
    username: string;
    password: string;
}
